import { Link } from "@tanstack/react-router";
import * as m from "~/paraglide/messages.js";

/**
 * The five systems Lindevo runs itself, as a strip of their case-study covers.
 * Static on purpose: the home page has no loader (see the route), so the slugs
 * and covers are known here rather than fetched.
 */
const SYSTEMS = [
  ["blog-engine", () => m.cap_proof_blog()],
  ["lead-radar", () => m.cap_proof_leads()],
  ["ai-agent-team", () => m.cap_proof_agents()],
  ["ai-gateway", () => m.cap_proof_gateway()],
  ["ai-infrastructure", () => m.cap_proof_infra()],
] as const;

export function ProofRow() {
  return (
    <div className="cap-proof">
      <div className="cap-proof-head">
        <h3>{m.cap_proof_title()}</h3>
        <p>{m.cap_proof_note()}</p>
      </div>
      <ul>
        {SYSTEMS.map(([slug, name]) => (
          <li key={slug}>
            <Link params={{ projectId: slug }} to="/projects/$projectId">
              <img
                alt=""
                height={630}
                loading="lazy"
                src={`/images/projects/${slug}/cover-v2.webp`}
                width={1200}
              />
              <span>{name()}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
